<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  add,
  getTimezone,
  getDetails,
  update,
  del
} from "@/api/system/timezone";

import cTable from "@/base/common/index";
export default {
  name: "timezone",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getTimezone,
        getDetails,
        del,
        add,
        update
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = this.$refs["form"].handleFilterData();
              data.id = row.id;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  type: "string",
                  message: "timezoneName cannot be empty",
                  trigger: "blur"
                }
              ],
              format: [
                {
                  required: true,
                  type: "string",
                  message: "timezoneFormat cannot be empty",
                  trigger: "blur"
                }
              ],
            }
          },
          grid: [{ title: 24 }, { format: 24 }, {beijing_time_difference:24}],
          fields: [
            {
              name: () => this.$t("timezoneName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("timezoneName");
              }
            },
            {
              name: () => this.$t("timezoneFormat"),
              key: "format",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("timezoneFormat");
              }
            },
            {
              name: () => this.$t("beijing_time_difference"),
              key: "beijing_time_difference",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("beijing_time_difference");
              },
			  bind:{
				  style:'width:100%',
			  },
				default:0
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 152
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("timezoneName"),
          key: "title",
          align: "left"
        },
        {
          name: () => this.$t("timezoneFormat"),
          key: "format",
          align: "left"
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 153
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 154
              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
